module.exports = __webpack_public_path__ + "static/media/team_02.f2133c35.jpg";